<template>
  <div class="music">
    <span class="music-btn" :class="{'music-btn-ant': flag}" @click.stop="musicFn"></span>
    <audio id="music-main" :src="musicUrl" autoplay preload loop ref="musicEl"></audio>
  </div>
</template>

<script>
export default {
  name: 'Music',
  data () {
    return {
      musicUrl: require('../../assets/1.mp3'),
      flag: true
    }
  },
  methods: {
    musicFn () {
      this.flag ? this.pauseFn() : this.playFn()
    },
    playFn () {
      this.$refs.musicEl.play()
      this.flag = true
    },
    pauseFn () {
      this.$refs.musicEl.pause()
      this.flag = false
    }
  },
  mounted () {
    this.playFn()
    this.pauseFn()
    document.addEventListener('WeixinJSBridgeReady', () => {
      this.playFn()
      this.pauseFn()
    }, false)
  }
}
</script>

<style scoped>
.music{
  width: 0;
  height: 0;
  overflow: hidden;
}
.music-btn{
  position: fixed;
  top: 2%;
  right: 2%;
  z-index: 999;
  width: 30px;
  height: 30px;
  background: url(../../assets/images/music.png) center no-repeat;
  background-size: 100%;
}
.music-btn-ant{
  -webkit-animation: rotating 1.2s linear infinite;
  animation: rotating 1.2s linear infinite;
}
@-webkit-keyframes rotating {
  0%{
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100%{
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes rotating {
  0%{
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100%{
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
</style>
